export const enableDocumentScrollSDKFactory = api => ({
    set documentScrollEnabled(isDocumentScrollEnabled) {
        api.setProps({ isDocumentScrollEnabled });
    },
    get documentScrollEnabled() {
        return api.props.isDocumentScrollEnabled ?? false;
    },
});
//# sourceMappingURL=enableDocumentScrollSDKFactory.js.map